import React from 'react'

const MaxWidthWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='imm_admin__max_width_wrapper'>{children}</div>
  )
}

export default MaxWidthWrapper